// import authImg from "assets/img/atrium/promo.png";
import Footer from "components/footer/FooterAuthDefault";
import BackIcon from "components/icons/BackIcon";
import { Link } from "react-router-dom";
import signIn from "assets/img/atrium/signimage.png";

function Default({ maincard, back }) {
  return (
    <div className="relative block xl:flex xl:flex-row w-full">
      <div className="flex-1 flex flex-col min-h-[100dvh] items-center">
        <div className="flex flex-col flex-1 px-4 w-full md:max-w-[420px]">
          {back && (
            <div className="mt-8">
              <Link
                to={back}
                className="text-gray-700 dark:text-gray-700 font-bold text-lg"
              >
                <span className="inline-block align-middle">
                  <BackIcon />
                </span>
                <span className="inline-block align-middle ml-4">Back</span>
              </Link>
            </div>
          )}

          <div className="flex-1 flex items-center justify-center">
            {maincard}
          </div>
        </div>

        <Footer />
      </div>

      {/* <img alt="" src={signInImage} className="hidden xl:block max-h-screen" /> */}
      <div className="relative hidden xl:block max-h-screen w-[45%]">
        {/* <img alt="" src="/signimage.png" className="h-full w-full object-cover" /> */}
        <img alt="" src={signIn} className="h-full w-full object-cover" />
        <div className="absolute bottom-4 left-4 right-4 text-white text-sm md:text-base font-medium bg-black/50 p-4 rounded-md">
          “Atrium AI is pioneering a new era in church engagement—turning raw
          data into real ministry insights. It’s one of the most missionally
          aligned platforms we’ve seen.”
          <br />
          <span className="mt-2 block text-center font-semibold">
            — Amar Patel, Missional Labs
          </span>
        </div>
      </div>

      {/* <div className="flex-1 hidden xl:block">
        <div className="relative flex h-full w-full">
          <div
            style={{ backgroundImage: `url(${authImg})` }}
            className="flex h-full w-full bg-cover"
          />
        </div>      
      </div> */}
    </div>
  );
}

export default Default;
